import { OfflineBanner } from "@/components/OfflineBanner";
import { AppRoutes } from "./routes";

/**
 * App root — installs the global offline banner above the route outlet
 * so it sits above the sticky TripHeader on every screen.
 */
export function App() {
  return (
    <>
      <OfflineBanner />
      <AppRoutes />
    </>
  );
}
